<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card class="card--shadow">
            <list :clinics="clinics" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import List from "@/components/clinic/List";
import { mapState } from "vuex";

export default {
  components: {
    List,
  },
  computed: {
    ...mapState("Clinic", ["clinics"]),
  },
  created() {
    this.$store.dispatch("Clinic/get");
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
